import configs from '@configs';
import { toast } from 'react-toastify';

interface IApi {
  request: (url: string, params: any) => Promise<any>
}

const API_URL = configs.get(process.env.REACT_APP_ENV || 'local').API_HOST;

export default class Api implements IApi {
  request = async (url: string, params = {}, customToken = null) => {
    const defaultParams = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const token = await localStorage.getItem('klass_access_token');

    if (customToken) {
      defaultParams.headers.Authorization = customToken;
    } else if (token) {
      defaultParams.headers.Authorization = token;
    }

    try {
      const response = await fetch(`${API_URL}/${url}`, Object.assign(defaultParams, params));

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
      }
      const json = await response.json();
      return json;
    } catch (error) {
      toast.error(error.message);
      throw error;
    }
  };
}
